import { useState } from "react";
import { api } from "../../api";
import { ErrorNote, Loading } from "../../components/Feedback";
import { Card } from "../../components/Shared";
import { useApi } from "../../useApi";
import { SuccessNote, SwitchRow } from "./parts";

// Management -> Project addresses (task 2026-10-05-each-project-has-its-own-address).
// GET/PUT /api/admin/addresses {enabled} -> {enabled, base_url, example_url}. The URLs come
// from the backend (FRONTEND_URL), never from this page's own host.

export default function AddressesCard() {
  const r = useApi("/admin/addresses");
  const [saved, setSaved] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const data = saved || r.data;

  const change = async enabled => {
    setBusy(true);
    setError(null);
    try {
      setSaved(await api.put("/admin/addresses", { enabled }));
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  };

  if (r.loading) return <Loading />;
  if (r.error) return <ErrorNote error={r.error} />;
  return (
    <Card>
      <h2 style={{ margin: "0 0 12px", fontSize: 18, fontWeight: 700 }}>Project addresses</h2>
      <ErrorNote error={error} />
      {saved && <SuccessNote>Saved: project addresses are {saved.enabled ? "on" : "off"}.</SuccessNote>}
      <SwitchRow label="Project addresses" checked={data.enabled} onChange={change} disabled={busy}
                 hint={<>A hosted project opens at its own address, such as <code>{data.example_url}</code>.
                   The portal itself stays at <code>{data.base_url}</code>.</>} />
      <p style={{ fontSize: 13, color: "#4b5563", margin: "14px 0 0" }}>
        Switch this on only once every <code>*.</code>name of the portal reaches it: a wildcard DNS
        entry and the wildcard Ingress rule (in compose, <code>*.localhost</code> works in browsers
        without either). People sign in on the portal as usual; the project address is handed a
        one-time code and needs no change in Keycloak.
      </p>
    </Card>
  );
}
